/**
 * The owner's message when no store password can be saved because the
 * environment has no encryption key configured (Bug Intake #496). The route
 * answers that with 503 + ``code: "store_password_storage_unavailable"``; it
 * is the one 5xx with an owner-facing meaning, and its wording lives HERE
 * (the server's text is never shown for a 5xx).
 */
export const STORAGE_UNAVAILABLE_MESSAGE =
  "Store passwords can't be saved in this environment yet, so the new password was not saved. Please contact ThreadFlow support.";

const STORAGE_UNAVAILABLE_CODE = "store_password_storage_unavailable";

/**
 * The message to show the owner when ``POST /campaign/updateShopper``
 * refuses a save, or null when the response is not a refusal.
 *
 * The route answers its password refusals ("Choose a store password",
 * "Store passwords must be at least 8 characters") with a 400 and its other
 * refusals ("Incorrect shopper Password", "Shopper account already
 * exists", ...) with a 200 whose body carries ``error``. Both are written
 * for the owner. A 5xx is not: its body can carry raw exception text, so it
 * never yields a message here (the same disclosure rule as raiseError in
 * store/notification.js) -- except the no-key 503 above, which yields the
 * fixed STORAGE_UNAVAILABLE_MESSAGE, never the server's text.
 *
 * @param {{status?: number, data?: any} | undefined} response an axios
 *   response, or ``err.response`` from a rejected request
 * @returns {string | null}
 */
export function shopperSaveRefusal(response) {
  if (!response) return null;
  const status = response.status;
  if (status === 503 && response.data && response.data.code === STORAGE_UNAVAILABLE_CODE) {
    return STORAGE_UNAVAILABLE_MESSAGE;
  }
  if (typeof status === "number" && (status < 200 || status >= 500)) {
    return null;
  }
  const error = response.data && response.data.error;
  return typeof error === "string" && error.trim() ? error.trim() : null;
}
